let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8bdOt")).then(() => parcelRequire('hX8BJ'));